module.exports = __webpack_public_path__ + "static/media/When Two Became One.22c1c4fe.png";